module.exports = __webpack_public_path__ + "static/6-e6269a97705cdc06305fbce321041787.jpg";